module.exports = __webpack_public_path__ + "img/foto-passaporte.d9449737.png";